import React from 'react'


export function IcRoundMinus(props) {
  return (
    <svg className='icons-style' width="1.5em" height="1.5em" viewBox="0 0 24 24" style={{ background : "rgba(0,0,0,0.1)"}} {...props}><path fill="currentColor" d="M19 12.998H5v-2h14z"></path></svg>
  )
}
export default IcRoundMinus